var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.41379 7.72096L9.48479 14.1553L8.07079 15.4419L0.292786 8.3643C0.105315 8.19366 0 7.96225 0 7.72096C0 7.47968 0.105315 7.24827 0.292786 7.07763L8.07079 0L9.48479 1.28668L2.41379 7.72096Z",
    fill: "#3D6B59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextLeftIcon);
export default __webpack_public_path__ + "static/media/next_left_icon.d3ba9a1dd16cf1c0fc834b9ff71574af.svg";
export { ForwardRef as ReactComponent };